import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Login from "../Component/Authentication/Login";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoute from "./PrivateRoute";

const RouterData = () => {
  const login = JSON.parse(localStorage.getItem("login")!);
  return (
    <BrowserRouter basename={"/"}>
      <Routes>
        {login ? (
          <>
            <Route
              path={`${process.env.PUBLIC_URL}` || '/'}
              element={
                <Navigate to={`${process.env.PUBLIC_URL}/pages/samplepage`} />
              }
            />

          </>
        ) : (
          <>
            <Route path={`/`} element={<Login />} />
            <Route path={`${process.env.PUBLIC_URL}`} element={<Login />} />
            <Route path={`${process.env.PUBLIC_URL}/login`} element={<Login />} />
          </>
        )}
        <Route path={`/`} element={<Login />} />
        <Route path={`${process.env.PUBLIC_URL}`} element={<Login />} />
        <Route path={`${process.env.PUBLIC_URL}/login`} element={<Login />} />
        <Route path={"/"} element={<PrivateRoute />}>
          <Route path={`/*`} element={<LayoutRoutes />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default RouterData;

